import { useSelector } from 'react-redux'
import { RootState } from '../redux/reducers/rootReducer'
import { checkStockQuantityByItemType } from '../utils/utils'

export function useCartHasStockError(): boolean {
  const cart = useSelector((state: RootState) => state.cart)
  const stock = useSelector((state: RootState) => state.stock)

  if (!cart?.item?.items?.length) return false
  if (!stock?.stockBasket?.length) return false

  return cart.item.items.some((product) => {
    const availability = checkStockQuantityByItemType(
      stock,
      product.product.variants[0],
      product.type as 'SECOND_HAND' | 'RENTAL',
      'basket'
    )
    return product.quantity > (availability ?? 0)
  })
}
